import Vue from 'vue'
import Router from 'vue-router'

import Home from './home'
import Member from './member'
import Project from './project'
import Pay from './pay'
import Info from './info'
import Finance from './finance'
import Tax from './tax'
import Agreement from '../pages/Agreement'
import MemberAgreement from '../pages/MemberAgreement'
import Account from './account'
import Licence from '../pages/Lisence'
import View from '../pages/Units/View'
import Maintenance from '../pages/Units/Maintenance'

const Login = () => import('../pages/Login')
const Index = () => import('../pages/Index.vue')

const HomeIndex = () => import('../pages/Home/Index.vue')
const MemberIndex = () => import('../pages/Member/Index')
const ProjectIndex = () => import('../pages/Project/Index')
const PayIndex = () => import('../pages/Pay/Index')
const InfoIndex = () => import('../pages/Info/Index')
const FinanceIndex = () => import('../pages/Finance/Index')
const TaxIndex = () => import('../pages/Tax/Index.vue')
const AccountIndex = () => import('../pages/Account/Index')

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        }, {
            path: '/',
            redirect: '/login'
        }, {
            path: '',
            redirect: '/login'
        }, {
            path: '/view',
            component: View
        }, {
            path: '/maintenance',
            component: Maintenance
        }, {
            path: '/agreement',
            name: 'agreement',
            component: Agreement
        }, {
            path: '/lisence',
            name: 'licence',
            component: Licence
        }, {
            path: '/terms',
            name: 'terms',
            component: () => import('@/pages/Terms')
        }, {
            path: '/memberagreement',
            name: 'memberagreement',
            component: MemberAgreement
        }, {
            path: '/index',
            component: Index,
            children: [{
                path: 'home',
                component: HomeIndex,
                children: Home
            }, {
                path: 'member',
                component: MemberIndex,
                children: Member
            }, {
                path: 'project',
                component: ProjectIndex,
                children: Project
            }, {
                path: 'pay',
                component: PayIndex,
                children: Pay
            }, {
                path: 'info',
                component: InfoIndex,
                children: Info
            }, {
                path: 'finance',
                component: FinanceIndex,
                children: Finance
            }, {
                path: 'tax',
                component: TaxIndex,
                children: Tax
            }, {
                path: '',
                redirect: 'home'
            }]
        }, {
            path: '/account',
            component: AccountIndex,
            children: Account
        }, {
            path: '*',
            redirect: '/login'
        }
    ]
})
